import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import apiClient from '../../apiClient';
import './VendorForm.scss';
import SharedDetails from '../../Components/SharedDetails/SharedDetails';
import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';

const vendorColumns = [{ title: 'Vendor Name', field: 'VendorName' }];
const vendorCsvHeaders = [{ label: 'Vendor Name', key: 'VendorName' }];

class VendorForm extends React.Component {
    state = {
      listVersion: 0,
        formData: {
            vendorname: '',
            address: '',
        },
        submitted: false,
        successMessage:null,
        errorMessage:null,
    }

    componentDidMount() {
      sessionStorage.setItem('TranSearch', null);
      sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
      let user = JSON.parse(sessionStorage.getItem('user'));
         if(user.permissions.filter(x=>x.PermissionName == 'Vendor' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }
     
    }

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    handleSubmit = () => {
        const { formData } = this.state;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = user.accessToken;


        const params = {
            tablename:  'vendor' ,
            queryvalue: formData.vendorname
          };

        apiClient.get(`/api/get/checkduplicateexist`  ,  { params: params ,headers: {"Authorization" : `Bearer ${accessToken}`} })
            .then(res => {
               
                if(res.data == 'duplicate')
                {
                    this.setState({ errorMessage: 'Vendor already exist, Please enter another vendor.' });

                    
                    setTimeout(() => {
                    this.setState({ errorMessage: null });
                    }, 10000);

                }else{

                    this.setState({ submitted: true }, () => {
                        setTimeout(() => this.setState({ 
                            formData: {
                                vendorname: '',
                                address: '',
                            },
                            submitted: false
                         }), 2000);
                    });
            
                    /**
                     * POST REQUEST
                     */
                   
                   
                    apiClient.post(`/api/post/vendor`, { formData }, { headers: {"Authorization" : `Bearer ${accessToken}`} })
                  .then(res => {
                      const result = res.data;
                      this.setState({ result });
                    this.setState({ successMessage: 'Successfully saved!' });
            
                   
                    setTimeout(() => {
                      this.setState({ successMessage: null });
                    }, 3000);

                    this.setState((state) => ({ listVersion: state.listVersion + 1 }));
                  })
                  .catch(error => notifyApiError(
                    this.props.showFlashNotification,
                    error,
                    'Unable to save vendor.'
                  ));
                      

                }
           

            })
            .catch(error => notifyApiError(
              this.props.showFlashNotification,
              error,
              'Unable to check whether the vendor already exists.'
            ));


       
    }

    render() {
        const { formData, submitted } = this.state;
        return (
        <div className="VendorForm">
          
                  
            <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
            >
                <h2>Vendor Form</h2>
                <TextValidator
                    label="Vendor Name"
                    onChange={this.handleChange}
                    name="vendorname"
                    value={formData.vendorname}
                    validators={['required']}
                    errorMessages={['this field is required']}
                />
                
               
               
                <br /><br /><br />
                <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    disabled={submitted}
                >
                    {
                        (submitted && 'Your form is submitted!')
                        || (!submitted && 'Submit')
                    }
                </Button>

                 
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}
         {this.state.errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {this.state.errorMessage}
        </div>
      )}
            </ValidatorForm>

            <SharedDetails
              columns={vendorColumns}
              csvFilename="vendor-details.csv"
              csvHeaders={vendorCsvHeaders}
              emptyMessage="No vendor records found."
              errorMessage="Unable to load vendors. Please try again."
              loadingMessage="Loading vendors..."
              pagedEndpoint="/api/get/vendor/paged"
              reloadKey={this.state.listVersion}
              style={{ maxWidth: '100%', paddingTop: '50px' }}
              title="Vendor Details"
            />
         </div>
        
        );
    }
}

export default withFlashNotification(VendorForm);
